import { Component, Input, OnInit } from '@angular/core';
import { FormattingPipe } from '../../detalle-inversion/pipes/formatting.pipe';
import { SharedDataService } from '../services/shared-data.service';
import { MaterialModule } from '../../material/material.module';
import { CommonModule } from '@angular/common';

export interface PeriodicElement {
  date: string;
  inversionInicial: any;
  inversionFinal: any;
  simpli: any;
  dap: any;
  rentabilidadSimpli: any;
}

@Component({
  selector: 'app-tabla-inversiones',
  standalone: true,
  imports: [MaterialModule, CommonModule,FormattingPipe],
  templateUrl: './tabla-inversiones.component.html',
  styleUrl: './tabla-inversiones.component.less'
})
export class TablaInversionesComponent implements OnInit {
  @Input() title!: string;
  @Input() subtitle!: string;

  displayedColumns: string[] = ['date', 'inversionInicial', 'inversionFinal', 'simpli', 'dap', 'rentabilidadSimpli'];
  dataSource: PeriodicElement[] = [];
  showSpinner: boolean = true;
  loading: boolean = true;

  constructor(
    private sharedDataService: SharedDataService,
  ) {}

  ngOnInit(): void {
    this.loading = true;
  
    this.sharedDataService.simulacionData$.subscribe(data => {
      if (data) {
        this.processSimulacionData(data.investor_details);
      } else {
        this.loading = false;
      }
    });
  }

  processSimulacionData(investorDetails: any) {

    this.dataSource = investorDetails.map((item: any) => ({
      date: this.formatDate(item.date) || '',
      inversionInicial: item.initial_investment || '',
      inversionFinal: item.final_investment || '',
      simpli: item.simpli_amount !== 0 ? item.simpli_amount : '-',
      dap: item.dap_amount !== 0 ? item.dap_amount : '-',
      rentabilidadSimpli: parseFloat((parseFloat(item.simpli_profitability) * 100).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    }));

    this.loading = false;
  }

  
  
  formatDate(dateString: string): string {
    const date = new Date(dateString);
    return `${('0' + date.getDate()).slice(-2)}/${('0' + (date.getMonth() + 1)).slice(-2)}/${date.getFullYear()}`;
  }

  resetDataSource(): void {
    this.dataSource = [];
    this.loading = true;
  }

}
